import React from 'react';
import './Banner.css';
import banner from '../assets/banner.png';

const Banner = () => {
  return (
    <div className="banner-container">
      <img
        src={banner}
        alt="Mountain Banner"
        className="banner-image"
      />
      {/* <div className="banner-overlay">
        <h1 className="banner-text">Opportunity</h1>

      </div> */}
    </div>
  );
};

export default Banner;
